import { FC } from "react";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router-dom";
import { useDeleteMutation } from "../../features/api/Api";
import Swal from "sweetalert2";
import { Button, styled } from "@mui/material";
import { deleteHandler } from "../../handlers";
import useLocales from "../../hooks/useLocales";

interface IDeleteButton {
  disabled: boolean;
  resource: string;
  redirectPath: string | any;
}

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  border: "1px solid #0062cc",
  fontSize: 16,
  padding: "6px 12px",
  lineHeight: 1.5,
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

const DeleteButton: FC<IDeleteButton> = ({
  disabled,
  resource,
  redirectPath,
}) => {
  const { translate } = useLocales();
  const history = useNavigate();
  const formik: any = useFormikContext();
  const [deleteRecord] = useDeleteMutation();

  function deleteMethod() {
    deleteRecord({
      resource: resource,
      params: { id: formik.values.id },
    })
      .unwrap()
      .then(() => {
        Swal.fire(translate("actions.saved"), "", "success");
        history(redirectPath);
      });
  }

  return (
    <BootstrapButton
      type="button"
      className="btn"
      disabled={disabled}
      onClick={() => deleteHandler(deleteMethod)}
      style={{ minWidth: "200px" }}
    >
      {translate("actions.delete")}
    </BootstrapButton>
  );
};
export default DeleteButton;
